(function ($) {
    $(document).ready(function () {

        const body = $("body");
        let canClick = true;

        $(".main-nav .menu-item-has-children").append("<i class='icon-down-open-mini'></i>");

        //toggle visibility mobile nav
        $(".mobile-nav-btn, .mobile-nav-wrap").on("click", () => {

            if (!body.hasClass("active-mobile-nav")) {
                body.addClass("active-mobile-nav");
                return
            }

           body.addClass("closing-mobile-nav").removeClass("active-mobile-nav");
            setTimeout(() => body.removeClass("closing-mobile-nav"), 300);

        })

        //stop propagation
        $(".mobile-nav-wrap .mobile-nav").on("click", (e) => {
            e.stopPropagation();
        })

        //toggle mobile sub-menu
        $(".menu-item-has-children").on("click", ".icon-down-open-mini", (e) => {
            if(canClick) {
                canClick = false;
                $(e.currentTarget).parent().find(".sub-menu").slideToggle(300);
                setTimeout(() => canClick = true, 300);
            }
        })

    })
})(jQuery);